/*
 * OBS Back-to-Top button
 * ---------------------
 * Adds a floating button that appears after the user scrolls down 400px.
 * Click → smoothly scrolls back to the top.
 */
(function () {
  'use strict';

  function init() {
    // Don't duplicate if already injected
    if (document.querySelector('.obs-back-to-top')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'obs-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4l-8 8h5v8h6v-8h5z"/></svg>';
    document.body.appendChild(btn);

    var visible = false;
    var threshold = 400;

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var shouldShow = y > threshold;
      if (shouldShow !== visible) {
        visible = shouldShow;
        btn.classList.toggle('is-visible', visible);
      }
    }

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // Throttle scroll via requestAnimationFrame
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
